import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../service/error.service';
import { LoggingService } from '../service/logging.service';
import { NotificationService } from '../service/notification.service';
import { Router } from '@angular/router';
import { Routes } from './utils';

export const GENERAL_ERROR_SUMMARY = 'Fehler';
export const GENERAL_SUCCESS_SUMMARY = '';
const UNKNOWN_ERROR_MESSAGE = 'Ein unbekannter Fehler ist aufgetreten.';
const OFFLINE_ERROR_MESSAGE = 'Bitte überprüfen Sie ihre Internetverbindung.';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private zone: NgZone) {}

  isOffline(): boolean {
    return !navigator.onLine;
  }

  handleError(thrownError: Error | HttpErrorResponse): void {
    const errorService = this.injector.get(ErrorService);
    const loggingService = this.injector.get(LoggingService);
    const notificationService = this.injector.get(NotificationService);
    const router = this.injector.get(Router);

    let message;
    let stackTrace;
    let status;
    let error;

    if (thrownError instanceof HttpErrorResponse) {
      // Server Error
      console.log('Server error occured...');
      if (this.isOffline()) {
        notificationService.showError(
          GENERAL_ERROR_SUMMARY,
          OFFLINE_ERROR_MESSAGE
        );
      } else {
        const serverError = errorService.getServerError(thrownError);
        error = serverError.error;
        message = serverError.message;
        status = serverError.status;

        if (status === 0) {
          notificationService.showError(
            GENERAL_ERROR_SUMMARY,
            UNKNOWN_ERROR_MESSAGE
          );
        } else {
          notificationService.showError(GENERAL_ERROR_SUMMARY, error);
        }
      }
    } else {
      // Client Error
      console.log('Client error occured...');
      message = errorService.getClientMessage(thrownError);
      stackTrace = errorService.getClientStack(thrownError);
      this.zone.run(() => {
        router.navigateByUrl(Routes.ERROR);
      });
    }

    loggingService.logError(message, stackTrace);
    console.error('ErrorHandler:', thrownError);
  }
}
